export default {
    TEXT_OTHER_DEVICES: 'Other devices',


    HEADER_TEXT_DATA_ROAMING: 'Turn on Data roaming on your device',
    TITLE_DATA_ROAMING_1: 'Step 1: Go to Cellular',
    DESC_DATA_ROAMING_1: 'Go to “Settings” on your device, then open “Cellular”',
    TITLE_DATA_ROAMING_2: 'Step 2: Choose SIM',
    DESC_DATA_ROAMING_2: 'Choose the SIM you used to activate International roaming service',
    TITLE_DATA_ROAMING_3: 'Step 3: Turn on Data Roaming',
    DESC_DATA_ROAMING_3: 'Check the network connection. If it still doesn’t work, move to Step 4.',
    TITLE_DATA_ROAMING_4: 'Step 4: Check network connection',
    DESC_DATA_ROAMING_4: 'Make sure you\'re connected to a supported network based on your plan. If not, go to Step 5.<br>Check supported networks <a class="clickable-redirect-type-2">here</a>',
    TITLE_DATA_ROAMING_5: 'Step 5: Network Selection',
    DESC_DATA_ROAMING_5: 'Tap “Network Selection” to set up network connection',
    TITLE_DATA_ROAMING_6: 'Step 6: Set up the network',
    DESC_DATA_ROAMING_6: 'Turn off “Automatic” and select a supported network from the list. If no supported networks are shown, call <a href="tel:+84912481111">+8491 248 1111</a> for free support.',
    TITLE_DATA_ROAMING_OTHER_1: 'Step 1: Go to SIM cards & mobile networks',
    DESC_DATA_ROAMING_OTHER_1: 'Go to “Settings” on your device, then open “SIM cards & mobile networks',
    TITLE_DATA_ROAMING_OTHER_2: 'Step 2: Choose Data roaming',
    DESC_DATA_ROAMING_OTHER_2: 'Tap to choose “Data roaming”',
    TITLE_DATA_ROAMING_OTHER_3: 'Step 3: Turn on International roaming',
    DESC_DATA_ROAMING_OTHER_3: 'Tap the status and switch it to “Always”.<br>If the service still doesn’t work, continue to Step 4.',
    TITLE_DATA_ROAMING_OTHER_4: 'Step 4: Choose SIM',
    DESC_DATA_ROAMING_OTHER_4: 'Go back to “SIM cards & mobile networks”.<br>Choose the SIM with the active International Roaming plan.',
    TITLE_DATA_ROAMING_OTHER_5: 'Step 5: Select network',
    DESC_DATA_ROAMING_OTHER_5: 'Tap “Mobile networks” to set up the network connection',
    TITLE_DATA_ROAMING_OTHER_6: 'Step 6: Check network connection',
    DESC_DATA_ROAMING_OTHER_6: 'Turn off “Automatically select network” and check if the connected network matches the supported ones in your plan. If it doesn’t, go to Step 7.',
    TITLE_DATA_ROAMING_OTHER_7: 'Step 7: Select network manually',
    DESC_DATA_ROAMING_OTHER_7: 'Select a supported network based on your plan.<br>If the service still doesn\'t work, call <a href="tel:+84912481111">+8491 248 1111</a> for free support. Check supported networks <a class="clickable-redirect-type-2">here</a>',


    HEADER_TEXT_SCOPE: 'Check where your plan can be used',
    TITLE_SCOPE_1: 'Step 1: Go to Telecom',
    DESC_SCOPE_1: 'On My VNPT home screen, tap “Telecom”',
    TITLE_SCOPE_2: 'Step 2: Go to Mobile',
    DESC_SCOPE_2: 'In “My services”, tap “Mobile”',
    TITLE_SCOPE_3: 'Step 3: Go to International roaming',
    DESC_SCOPE_3: 'In “Mobile utilities”, tap “International roaming”',
    TITLE_SCOPE_4: 'Step 4: Check plan information',
    DESC_SCOPE_4: 'Tap the “i” icon to view your current plan details',
    TITLE_SCOPE_5: 'Step 5: Check where your plan can be used',
    DESC_SCOPE_5: 'Scroll down to see the applicable countries list',


    HEADER_TEXT_REMAINING_TRAFFIC: 'Check your remaining usage',
    TITLE_REMAINING_TRAFFIC_1: 'Step 1: Go to Telecom',
    DESC_REMAINING_TRAFFIC_1: 'On My VNPT home screen, tap “Telecom”',
    TITLE_REMAINING_TRAFFIC_2: 'Step 2: Go to Mobile',
    DESC_REMAINING_TRAFFIC_2: 'In “My services”, tap “Mobile”',
    TITLE_REMAINING_TRAFFIC_3: 'Step 3: Check your remaining usage',
    DESC_REMAINING_TRAFFIC_3: 'In the Remaining usage section, you’ll see details for all services in your plan',


    HEADER_TEXT_CANCEL_SERVICE: 'How to cancel the service',
    TITLE_CANCEL_SERVICE_1: 'Option 1: Send a text message',
    TITLE_CANCEL_SERVICE_2: 'Option 2: Cancel in My VNPT app',
    DESC_CANCEL_SERVICE_1: 'Text HUY CVQT or IR OFF to 9123 (free of charge)',
    DESC_CANCEL_SERVICE_2: 'Step 1: Open the app then go to “Telecom”',
    DESC_CANCEL_SERVICE_3: 'Step 2: In “My services”, tap “Mobile”',
    DESC_CANCEL_SERVICE_4: 'Step 3: In “Mobile utilities”, tap “International roaming”',
    DESC_CANCEL_SERVICE_5: 'Step 4: Tap the service toggle icon',
    DESC_CANCEL_SERVICE_6: 'Step 5: Tap “Turn off service”',


    HEADER_TEXT_CANCEL_PACKAGE: 'How to cancel the plan',
    TITLE_CANCEL_PACKAGE_1: 'Step 1: Go to Telecom',
    DESC_CANCEL_PACKAGE_1: 'On My VNPT home screen, tap “Telecom”',
    TITLE_CANCEL_PACKAGE_2: 'Step 2: Go to Mobile',
    DESC_CANCEL_PACKAGE_2: 'In “My services”, tap “Mobile”',
    TITLE_CANCEL_PACKAGE_3: 'Step 3: International roaming',
    DESC_CANCEL_PACKAGE_3: 'In “Mobile utilities”, tap “International roaming”',
    TITLE_CANCEL_PACKAGE_4: 'Step 4: Check plan information',
    DESC_CANCEL_PACKAGE_4: 'Tap the “i” icon to view your current plan details',
    TITLE_CANCEL_PACKAGE_5: 'Step 5: Cancel the plan',
    DESC_CANCEL_PACKAGE_5: 'Tap “Cancel plan”'


};